import store from 'store';

export const saveToLocalStorage = (key, value) => {
    store.set(key, value);
};

export const getFromLocalStorage = key => {
    return store.get(key) || '';
};
